<template>
  <div>
    <h3 class="text-center font-weight-bold pb-3">Professional future</h3>
    <template v-if="editable">
      <div class="user-profile-name d-flex align-items-end mb-3">
        <div class="flex-grow-1">What I want my Manager to know about my professionnal aspirations/goals</div>
        <b-button variant="link" size="lg" @click.prevent="$emit('edit', { profile, from: 'professional-future' })">
          <edit-pen-icon :style="{fontSize: '1.5rem'}" />
        </b-button>
      </div>
      <div class="bg-color-darkgray2 p-3 rounded">
        <toggle-button
          :value="value"
          :height="30"
          color="#4A90E2"
          class="m-0"
          @change="$emit('change', $event)"
        />
        <span v-if="value" class="font-italic ml-3 text-white">
          This section is displayed to all
        </span>
        <span v-else class="font-italic ml-3 color-lightgray">
          This section is private to me and my manager
        </span>
      </div>
    </template>
    <b-row>
      <b-col cols="12" md="auto">
        <timeline v-model="active" :options="options" class="mt-2 mb-2" />
      </b-col>
      <b-col cols="12" md align-self="center" class="p-0 p-md-5">
        <div v-if="activeGoal" class="bg-color-lightgray2 rounded-xl">
          <div class="p-3">
            <div class="text-right color-gray">{{date}}</div>
            <div class="quoted text-indent font-italic">
              {{activeGoal}}
            </div>
          </div>
        </div>
        <div v-else class="font-italic">
          This section is empty
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import moment from 'moment'
import Timeline from '@/components/common/Timeline'
import EditPenIcon from '@/assets/images/edit-pen.svg'

export default {
  name: 'ProfessionalFuture',

  model: {
    prop: 'value',
    event: 'change'
  },

  props: {
    value: {
      type: Boolean
    },

    editable: {
      type: Boolean
    },

    profile: {
      type: Object,
      default: () => ({})
    }
  },

  computed: {
    activeGoal() {
      switch (this.active) {
        case 'short': return this.profile.shortTermGoals
        case 'mid': return this.profile.midTermGoals
        case 'long': return this.profile.longTermGoals
      }
      return ''
    },

    date() {
      let date = ''
      switch (this.active) {
        case 'short':
          date = this.profile.shortTermGoalsUpdatedAt
          break
        case 'mid':
          date = this.profile.midTermGoalsUpdatedAt
          break
        case 'long':
          date = this.profile.longTermGoalsUpdatedAt
          break
      }
      return date ? moment(date).fromNow() : ''
    }
  },

  data() {
    return {
      options: [
        { value: 'short', title: 'Short term', subtitle: 'One year' },
        { value: 'mid', title: 'Mid term', subtitle: 'Three years' },
        { value: 'long', title: 'Long term', subtitle: 'Five years' }
      ],
      active: 'short'
    }
  },

  components: {
    EditPenIcon,
    Timeline
  }
}
</script>
